<!-- 接收到视频链接直接播放页面 -->
<template>
  <div>
    <div class="video-box">
      <div
        :class="['v-video-wrap', isRotate ? 'v-rotate-90' : '']"
        @click.stop=""
      >
        <video
          :src="mediaUrl"
          class="v-video"
          controls
          :autoplay="true"
          id="myVideo"
          :muted="muted"
          oncontextmenu="return false;"
          controlsList='nodownload noremote footbar'
        >
          <source :src="mediaUrl" type="video/mp4" />
        </video>
        <span class="v-all-screen" @click.stop="allScreen">全屏</span>
      </div>
      <div class="video-play-btn" v-if="showPlay" @click="play">
        <img src="@/assets/icon_vedio.png">
      </div>
    </div>
    <div v-if="!isPlayer" class="load-text">努力加载中...</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      mediaUrl: "",
      isPlayer: false,
      isRotate: false,
      muted: true,
      vid: "",
      showPlay: true
    };
  },
  methods: {
    play() {
      this.showPlay = false
      this.vdom.play()
    },
    allScreen() {
      this.isRotate = !this.isRotate;
      console.log("全屏");
    },
  },
  created() {
    var url = this.$route.query.video;
    var type = this.$route.query.type;
    this.mediaUrl = this.$route.query.video;
    if (url.indexOf("https://") == -1 && url) {
      this.mediaUrl = "https://" + this.$route.query.video;
    }
    if (type == 'base64') {   // 解决移动端URL链接后不能再拼接http链接问题，将http/https链接转换为base64
      let decodedData = window.atob(url);
      this.mediaUrl = decodedData;
    }
    this.vid = this.$route.query.vid;
    console.log(this.$route.query);
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") > -1) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          //在小程序中
          wx.miniProgram.redirectTo({
            url: "/pages/live/videoPlay/videoPlay?vid=" + this.vid,
          });
        }
      });
      return;
    }
    // this.isPlayer = true;
  },
  mounted() {
    // this.isPlayer = true;
    var _this = this;
    var vdom = document.getElementById("myVideo");
    this.vdom = vdom
    vdom.currentTime = 1
    vdom.addEventListener(
      "canplay",
      function() {
        _this.isPlayer = true;
        _this.muted = false
      },
      false
    );
  },
};
</script>
<style lang="scss" scoped>
.video-box {
  top: 0;
  /* position: fixed; */
  display: flex;
  position: fixed;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
}
.video-play-btn {
  width: 62px;
  height: 62px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.v-video {
  // width: 100%;
  object-fit: fill;
}
.v-video-wrap {
  position: relative;
  width: 100%;
  .v-all-screen {
    position: absolute;
    /*right: 0;
    bottom: 0;*/
    right: 12vw;
    bottom: 10vw;
    z-index: 99;
    background: red;
    padding: 2vw;
    opacity: 0;
  }
}

.v-rotate-90 {
  transform: rotate(90deg) scale(0.85);
  width: 100vh;
  .v-all-screen {
    right: 7.5vh;
    /*padding:2vw 5vw;*/
    /*bottom: 18vw;*/
    /*transform: scale(0.85);*/
  }
}

.v-video {
  width: 100%;
}

#id_test_video {
  height: 30vh;
}

video::-webkit-media-controls-fullscreen-button {
  /*display: none;*/
  pointer-events: none;
}
.load-text {
  color: red;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}
</style>
